// npm

import React, { Component } from "react";
import { withRouter } from "react-router-dom";

// material-ui
import Card from "@material-ui/core/Card";
import { MaterialText } from "components/presentation/material-text";

import CardContent from "@material-ui/core/CardContent";

import withStyles from "@material-ui/core/styles/withStyles";

// react
import { Align } from "components/layout/align";
import { AppPageModifier } from "components/pages/app-page-modifier";
import { api } from "libs/api/api";
import { check } from "@xams-utils/check-types";
import { ReturnToSchedulesButton } from "../../initialized/intro/page/return-to-schedules-button";

const getTitleMessage = (errorObj) => {
    let title = "Error (422)";
    let message = "There was a problem fetching your exam";

    if (check.nonEmptyObject(errorObj)) {
        const { error } = errorObj;
        if (error) {
            const { response } = error;
            if (check.nonEmptyString(response)) {
                const responseJson = JSON.parse(response);
                if (check.nonEmptyObject(responseJson)) {
                    const { error: errorTitle, reason } = responseJson;

                    if (check.nonEmptyString(errorTitle)) {
                        title = errorTitle.replace(/([A-Z])/g, " $1").trim();
                    }

                    if (check.nonEmptyString(reason)) {
                        message = reason;
                    }
                }
            }
        }
    }

    return { title, message };
};

class FetchingErrorPage extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { history } = this.props;
        history.push("/schedules");
    }

    render() {
        const { classes } = this.props;
        const { title, message } = getTitleMessage(api.errorObj);
        const appBarProps = {
            title,
            logo: true,
            logout: true,
        };

        return (
            <React.Fragment>
                <AppPageModifier
                    id="fetch-error"
                    appBarProps={appBarProps}
                />
                <Align top={true}>
                    <Card className={classes.card}>
                        <CardContent>
                            <div className={classes.message}>
                                <MaterialText>{message}</MaterialText>
                            </div>
                            <div className={classes.button}>
                                <Align right="true">
                                    <ReturnToSchedulesButton />
                                </Align>
                            </div>
                        </CardContent>
                    </Card>
                </Align>
            </React.Fragment>
        );
    }
}

const styles = ({ spacing }) => ({
    card: {
        marginTop: spacing.unit * 4,
    },
    button: {
        marginTop: spacing.unit * 2,
    },
    message: {
        marginTop: spacing.unit * 2,
    },
    extraInfo: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    paper: {
        padding: spacing.unit * 2,
    },
    errorInfo: {
        maxHeight: "50vh",
        overflowY: "scroll",
    },
});

FetchingErrorPage = withStyles(styles)(FetchingErrorPage);
FetchingErrorPage = withRouter(FetchingErrorPage);

export { FetchingErrorPage };
